angular.module('qkr').directive('horizontalNavbar', () => ({
		restrict: 'AE',
		link(scope, element, attributes) {
			scope.$watch(() => {
            	element.find('div.tab-content').css('overflow', 'hidden');
	        }, true);
		}
	}));



// WEBPACK FOOTER //
// ./src/directives/horizontal_navbar.js